import { http_client } from '@/plugins/http_client';

const url = '/api/solicitudes/renuncia/catalogo';

const getTiposDocumentos = async ()=> await http_client(`${url}/tipos-documento`);
const getUnidadesOrganizativas = async (filtros={})=> await http_client(`${url}/unidades-organizativa`,filtros);
const getEstablecimientos = async (filtros={})=> await http_client(`${url}/establecimientos`, filtros);
const getEstados = async ()=> await http_client(`${url}/estados-renuncia`);
const getInstituciones = async ()=> await http_client(`${url}/instituciones`);

export default {
    getTiposDocumentos,
    getUnidadesOrganizativas,
    getEstablecimientos,
    getEstados,
    getInstituciones,
}